import { Button, Icon } from 'ui';

type P = {
  onClick: () => void;
};

const ContinueInBrowserButton = ({ onClick }: P) => (
  <Button icon={<Icon icon="arrow-right-line" />} iconPosition="end" onClick={onClick}>
    Or, continue in browser
  </Button>
);

export default ContinueInBrowserButton;
